import { CheckoutSettings } from '@pdqdev/pdq-shared/dist/entities';
export class SettingsDTO {
  values: Partial<CheckoutSettings>;
  oldValues: CheckoutSettings;

  constructor(values: Partial<CheckoutSettings>, oldValues: CheckoutSettings) {
    this.values = values;
    this.oldValues = oldValues;
  }

  buildSettingsDTO() {
    const settingsDTO: any = {};

    if (this.values.enableOptimization !== undefined) {
      settingsDTO.enableOptimization = this.values.enableOptimization;
    }

    settingsDTO.increaseRatesPercentage =
      (this.values.increaseRatesPercentage as any) === '' || isNaN(this.values.increaseRatesPercentage)
        ? null
        : +this.values.increaseRatesPercentage;

    if (this.values.isTestMode !== undefined) {
      settingsDTO.isTestMode = this.values.isTestMode;
    }

    if (this.values.scriptTagEnabled !== undefined) {
      settingsDTO.scriptTagEnabled = this.values.scriptTagEnabled;
    }

    if (
      this.values.scriptTagEnabled !== undefined &&
      this.values.scriptTagEnabled === this.oldValues.scriptTagEnabled
    ) {
      delete settingsDTO.scriptTagEnabled;
    }

    if (this.values.enableIncreaseRatesPercentage !== undefined) {
      settingsDTO.enableIncreaseRatesPercentage = this.values.enableIncreaseRatesPercentage;
    }

    if (this.values.runTestVariantsTogether !== undefined) {
      settingsDTO.runTestVariantsTogether = this.values.runTestVariantsTogether;
    }

    if (this.values.preventMultipleShippingCost !== undefined) {
      settingsDTO.preventMultipleShippingCost = this.values.preventMultipleShippingCost;
    }

    if (this.values.runTestVariantsTogether && !this.oldValues?.runTestVariantsTogether) {
      settingsDTO.originalVariantAppearance = 0;
      settingsDTO.testVariantAppearance = 0;
    }

    if (this.values.percentTestVariantTraffic) {
      settingsDTO.percentTestVariantTraffic = this.values.percentTestVariantTraffic;
    }

    if (
      this.values.percentTestVariantTraffic &&
      this.oldValues.percentTestVariantTraffic &&
      +this.values.percentTestVariantTraffic != this.oldValues.percentTestVariantTraffic
    ) {
      settingsDTO.percentTestVariantChanged = true;
      settingsDTO.originalVariantAppearance = 0;
      settingsDTO.testVariantAppearance = 0;
    }

    if (this.values.subTotalIncludesDiscounts !== undefined) {
      settingsDTO.subTotalIncludesDiscounts = this.values.subTotalIncludesDiscounts;
    }

    if (this.values.checkoutScriptTagManuallySet !== undefined) {
      settingsDTO.checkoutScriptTagManuallySet = this.values.checkoutScriptTagManuallySet;
    }

    if (
      this.values.enableDeliveryCustomization !== undefined &&
      this.values.enableDeliveryCustomization !== this.oldValues.enableDeliveryCustomization
    ) {
      settingsDTO.enableDeliveryCustomization = this.values.enableDeliveryCustomization;
    }

    if (
      this.values.pluginsScriptTagEnabled !== undefined &&
      this.values.pluginsScriptTagEnabled !== this.oldValues.pluginsScriptTagEnabled
    ) {
      settingsDTO.pluginsScriptTagEnabled = this.values.pluginsScriptTagEnabled;
    }

    if (this.values.enableCheckoutPrioritization !== undefined) {
      settingsDTO.enableCheckoutPrioritization = this.values.enableCheckoutPrioritization;
    }

    if (this.values.hasShippingMethodDiscount !== undefined) {
      settingsDTO.hasShippingMethodDiscount = this.values.hasShippingMethodDiscount;
    }

    if (this.values.shippingMethodDiscounts !== undefined) {
      settingsDTO.shippingMethodDiscounts = this.values.shippingMethodDiscounts;
    }

    return settingsDTO;
  }
}
